<div class="content">
  <i class="tag"
     *ngFor="let tag of tags">
    <{{tag.name}}>
  </i>
</div>
